import type { ReactNode } from 'react';
import React from 'react';
import type { FormatOptionLabelMeta } from 'react-select-modern';

import type { TFacebookCampaign } from '@feathr/blackbox';

import * as styles from './FacebookCampaignObjective.css';

export interface ICampaignObjective {
  id: TFacebookCampaign['objective_type'];
  name?: string;
  description: string;
}

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatCampaignObjectiveOptionLabel(
  data: ICampaignObjective,
  meta: FormatOptionLabelMeta<ICampaignObjective>,
): ReactNode {
  if (meta.context === 'value') {
    return data.name;
  }

  return (
    <>
      {data.name}
      <div className={styles.description}>
        <p>{data.description}</p>
      </div>
    </>
  );
}
